'use strict';
angular.module('theme').controller('futureMenusTabs', function ($scope) {
	$scope.model = {
		name: 'Tabs'
	};
});